import { defineComponent } from 'vue';
import { useAnimator } from '@/composables/animator';

export default defineComponent({
  methods: {
    animator(
      element: any,
      animation: any,
      additional = '',
      prefix = 'animate__',
    ) {
      return useAnimator().animator(element, animation, additional, prefix);
    },
  },
});
